export default {
  path: '/machines',
  name: 'machines',
  component: () => import('./_views/KernelMachines.vue'),
  meta: {
    title: 'Machines',
    navigation: {
      position: 3,
      name: 'Machines',
      icon: 'print',
      specialQueries: ['suffix'],
      to: {
        name: 'machines',
        query: {
          suffix: '',
          pageNum: '1',
        },
      },
    },
  },
};
